import { useWebSiteStore } from '@/stores/web-site.store'

export const useAuthService = () => {
  const {
    AUTH_SERVER_URL,
    AUTH_AUTHORIZATION_PATH,
    AUTH_CLIENT_ID,
    AUTH_SCOPES,
    AUTH_REDIRECT_URI
  } = window.config

  const getAuthorizationUri = () => {
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: AUTH_CLIENT_ID,
      scope: AUTH_SCOPES,
      redirect_uri: AUTH_REDIRECT_URI
    })

    return `${AUTH_SERVER_URL}${AUTH_AUTHORIZATION_PATH}?${params.toString()}`
  }

  const redirectToAuth = () => {
    const webSiteStore = useWebSiteStore()
    webSiteStore.clearTokenData()
    window.location.href = getAuthorizationUri()
  }

  const redirectToBaseAuth = () => {
    const webSiteStore = useWebSiteStore()
    webSiteStore.clearTokenData()
    window.location.href = `${AUTH_SERVER_URL}`
  }

  return {
    getAuthorizationUri,
    redirectToAuth,
    redirectToBaseAuth
  }
}
